import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import './App.css';

function TermsConditions() {
  return (
    <div className="App">
      <Navigation />
      
      <header className="App-header">
        <div className="page-content">
          <h1>Terms & Conditions</h1>
          
          <div className="legal-content">
            <p><strong>Last updated:</strong> October 28, 2025</p>
            
            <section className="legal-section">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using services of BlobCity iSolutions Pvt Ltd (hereinafter referred to as "BlobCity"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
            </section>

            <section className="legal-section">
              <h2>2. Service Description</h2>
              <p>BlobCity provides luxury vehicle rental services specifically for weddings and special events. Our services include vehicle rental, chauffeur services, and related support services.</p>
            </section>

            <section className="legal-section">
              <h2>3. Booking and Reservations</h2>
              <ul>
                <li>All bookings are subject to availability</li>
                <li>A deposit is required to confirm your reservation</li>
                <li>Full payment must be made before the service date</li>
                <li>Booking confirmations will be sent via email</li>
                <li>Changes to bookings may incur additional charges</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>4. Cancellation Policy</h2>
              <ul>
                <li>Cancellations made 7+ days before service: Full refund minus processing fee</li>
                <li>Cancellations made 7-3 days before service: Forfiture of deposit amount</li>
                <li>Cancellations made less than 72 hours before service: Forfiture of entire amount. No refund.</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>5. Vehicle Use and Responsibilities</h2>
              <ul>
                <li>Vehicles must be used responsibly and lawfully</li>
                <li>No smoking, eating, or drinking (except water) in vehicles</li>
                <li>Use or carrying of drugs, vapes, or any illegal substances is strictly prohibited</li>
                <li>Maximum passenger limits must be observed</li>
                <li>Decorations must be approved in advance</li>
                <li>Any damages will be charged to the customer</li>
                <li>Customers are responsible for the behavior of their guests</li>
                <li>BlobCity is not responsible for loss of any personal belongings / valuables of the guests</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>6. Chauffeur Services</h2>
              <ul>
                <li>Professional chauffeurs are provided with all rentals</li>
                <li>Chauffeurs determine routes and driving decisions for safety</li>
                <li>Service hours are as agreed in the booking contract</li>
                <li>Overtime charges apply for extended services</li>
                <li>Gratuities for chauffeurs are appreciated but not mandatory</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>7. Liability and Insurance</h2>
              <p>Hired vehicles have comprehensive insurance coverage. However, customers are responsible for:</p>
              <ul>
                <li>Personal belongings and valuables</li>
                <li>Any damages caused by customer negligence</li>
                <li>Additional cleaning fees if required</li>
                <li>Any traffic violations or fines incurred during service, due to a fault of the customer</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>8. Force Majeure</h2>
              <p>We are not liable for any failure to perform our obligations due to circumstances beyond our reasonable control, including but not limited to natural disasters, strikes, government actions, or other unforeseeable events.</p>
            </section>

            <section className="legal-section">
              <h2>9. Governing Law</h2>
              <p>These terms and conditions are governed by and construed in accordance with the laws of Mumbai, Maharastra, India, and you irrevocably submit to the exclusive jurisdiction of the courts of Mumbai.</p>
            </section>

            <section className="legal-section">
              <h2>10. Contact Information</h2>
              <p>For questions about these Terms & Conditions, please contact us at:</p>
              <p>
                <strong>BlobCity iSolutions Pvt Ltd</strong><br />
                Email: hello@vidaai.com<br />
                BlobCity c/o WeWork Enam Sambhav, C20, G Block<br />
                BKC, Bandra East, Mumbai, Maharashtra 400051. India.
              </p>
            </section>
          </div>
        </div>
      </header>
      
      <Footer />
    </div>
  );
}

export default TermsConditions;
